import React from "react";

// Components
import NavigationBack from "components/NavigationBack";

// Lib
import {decodeHtmlEntity} from "lib/helpers";

interface IHeaderLibrariesCompounds {
	id: string,
	totalElements?: string,
	state: {
		type: string,
		name: string,
		catNumber: string,
		description: string,
		currentValue: string,
		compoundsCount: number,
	},
}

export const Header: React.FC<IHeaderLibrariesCompounds> = (props) => {
	const {id, state, totalElements} = props;

	return (
		<div className="libraries-compounds__header flex flex-jc-between flex-direction-column mb30">
			<div className="librarimes-compounds__header-top flex flex-ai-center flex-jc-between mb10">
				<NavigationBack label={`Search / ${id}`} />
				<p className="libraries-compounds__header-compounds">Compounds all</p>
			</div>
			<div className="libraries-compounds__header-bottom flex flex-ai-center flex-jc-between">
				<h1
					className="libraries-compounds__main-title"
					dangerouslySetInnerHTML={{__html: decodeHtmlEntity(state?.name || '')}}
				/>
				<p className="libraries-compounds__compounds-number">{totalElements || ''}</p>
			</div>
		</div>
	);
};

export default Header;
